import { connect } from 'react-redux'
import StationUserTablePane from '../../components/station-user/StationUserTablePane'

import { actionCreators } from '../../state/actions/riders'
import { IStoreState } from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    currentOrgId: state.organizations.currentOrgId
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StationUserTablePane)



// WEBPACK FOOTER //
// ./src/containers/station-user/StationUserTablePane.ts